import React from "react"
import Components from '../../../components'
import Client from "../../../services"

class NewExamForm extends React.Component{
    state = {
        title: "",
        fullMarks: "100",
        nQuestions: "10",
        examDuration: "60",
    }

    componentDidMount(){

    }

    handleChange = (e) => {
        e.preventDefault()
        const {name, value} = e.target

        this.setState({
            [name]: value
        })
        this.props.onChange(name, value)
    }

    render(){
        
        return <div className="new-exam-form" >
            <Components.forms.SimpleForm>
                <table>
                    <tbody>
                        <tr>
                            <td>Course Name</td>
                            <td>
                                {`${this.props.course.title} [${this.props.course.symbol}]`}
                            </td>
                        </tr>
                        <tr>
                            <td>title</td>
                            <td><Components.input.TextInput placeholder="Title" name="title" value={this.state.title} onChange={this.handleChange}/></td>
                        </tr>
                        <tr>
                            <td>Full Marks</td>
                            <td>
                                <Components.input.TextInput placeholder="Full Marks" name="fullMarks" type="number" value={this.state.fullMarks} onChange={this.handleChange}/>
                            </td>
                        </tr>
                        <tr>
                            <td>No of Questions</td>
                            <td>
                                <Components.input.TextInput placeholder="No of Questions" name="nQuestions" type="number"  value={this.state.nQuestions}  onChange={this.handleChange}/>
                            </td>
                        </tr>
                        <tr>
                            <td>Exam Duration</td>
                            <td>
                                <Components.input.TextInput placeholder="Exam Duration" name="examDuration" type="number" value={this.state.examDuration}  onChange={this.handleChange}/>
                            </td>
                            <td>Minute(s)</td>
                        </tr>
                        
                    </tbody>
                </table>                
            </Components.forms.SimpleForm>
        </div>
    }
}

export default NewExamForm